import deleteMedia from '../../../Services/deleteMedia'

export default (media) => async (dispatch) => {

  dispatch(deleteMedia(media))
  
}
